import axios from '@axios'
import baseConfig from "@/../baseConfig";

export default {
  namespaced: true,
  state: {
    setting: {},
  },
  getters: {
    getSetting(state) {
      return state.setting
    },
  },
  mutations: {
    setSetting(state, {setting}) {
      let settings = setting.data
      Object.keys(settings).forEach(function (key, index) {
        if (typeof settings[key] !== 'undefined')
          if (settings[key].key === 'panelTheme' || settings[key].key === 'adminTheme')
            settings = settings[key].value;
      })


      document.cookie = "theme="+ settings
      state.setting = setting.data
    },
  },
  actions: {
    async setSetting({commit}) {
      const setting = await axios.get(baseConfig.baseUrl + 'login')
    //  console.log(setting)
      commit('setSetting', {setting})
    },
  },
}
